module.exports = __webpack_public_path__ + "img/financial-aid.5cd6521.jpg";